const questions = [
  {
    id: 1,
    name: "entry.827604619",
    type: "radio",
    title: "Quelle proportion de handicaps ne se voient pas ?",
    selectMax: 1,
    images: { left: "leopard-print.jpg", right: "question-1.png" },
    answers: [
      {
        label: "25 %",
        value: "25 %",
      },
      {
        label: "50 %",
        value: "50 %",
      },
      {
        label: "80 %",
        value: "80 %",
      },
      {
        label: "100 %",
        value: "100 %",
      },
    ],
    rightAnswers: [
      {
        answer: "80 %",
      },
    ],
    description:
      "80 % ! Soit dans 8 cas sur 10, le handicap est invisible.\n\n🤔 Cela signifie que, si la personne ne vous en parle pas, vous ne pouvez pas le savoir. Vous croisez donc probablement tous les jours des personnes en situation de handicap sans en être conscient.",
  },
  {
    id: 2,
    name: "entry.780519045",
    type: "radio",
    title:
      "Qui peut bénéficier d'une reconnaissance de la Qualité de Travailleur Handicapé (RQTH) ?",
    selectMax: 1,
    images: { left: "leopard-print2.jpg", right: "question-2.png" },
    answers: [
      {
        label: "Un acheteur avec une hernie discale",
        value: "Un acheteur avec une hernie discale",
      },
      {
        label: "Un vendeur avec une maladie temporaire (cancer)",
        value: "Un vendeur avec une maladie temporaire (cancer)",
      },
      {
        label: "Un comptable avec un trouble cognitif",
        value: "Un comptable avec un trouble cognitif",
      },
      {
        label: "Toutes les personnes ci-dessus",
        value: "Toutes les personnes ci-dessus",
      },
    ],
    rightAnswers: [
      {
        answer: "Toutes les personnes ci-dessus",
      },
    ],
    description:
      "Toutes ces personnes sont susceptibles de bénéficier de la RQTH car leur pathologie peut avoir une incidence sur le travail.\n\n💡 La RQTH est destinée aux personnes dont les capacités à obtenir ou conserver un emploi sont réduites en raison de la dégradation d'au moins une fonction physique, sensorielle, mentale ou psychique.",
  },
  {
    id: 3,
    name: "entry.2043220621",
    type: "radio",
    title:
      "Quel(s) obstacle(s) rencontre(nt) les personnes en situation de handicap au quotidien ?",
    selectMax: 1,
    images: { left: "leopard-print.jpg", right: "question-3.png" },
    answers: [
      {
        label: "L'inaccessibilité physique des lieux",
        value: "L'inaccessibilité physique des lieux",
      },
      {
        label: "Le manque d'adaptations technologiques",
        value: "Le manque d'adaptations technologiques",
      },
      {
        label: "Les préjugés et la méconnaissance des autres",
        value: "Les préjugés et la méconnaissance des autres",
      },
      {
        label: "Tous ces éléments",
        value: "Tous ces éléments",
      },
    ],
    rightAnswers: [
      {
        answer: "Tous ces éléments",
      },
    ],
    description:
      "Les personnes en situation de handicap font face à des obstacles comme l'accessibilité insuffisante (transports, bâtiments, technologies), le manque d'aménagements dans l'emploi ou l'éducation, et des préjugés sociaux.\n\n🚧 Ces barrières limitent l'autonomie et la participation à la société. Il est donc essentiel d'en avoir conscience pour favoriser l'inclusion.\n\n☝ C'est pourquoi vous avez également un rôle à jouer dans la lutte contre les préjugés en contribuant à lever les stéréotypes.",
  },
  {
    id: 4,
    name: "entry.469814758",
    type: "radio",
    title:
      "Le pourcentage de personnes en situation de handicap qui sont en fauteuil roulant est :",
    selectMax: 1,
    images: { left: "leopard-print2.jpg", right: "question-4.png" },
    answers: [
      {
        label: "3 %",
        value: "3 %",
      },
      {
        label: "15 %",
        value: "15 %",
      },
      {
        label: "50 %",
        value: "50 %",
      },
      {
        label: "80 %",
        value: "80 %",
      },
    ],
    rightAnswers: [
      {
        answer: "3 %",
      },
    ],
    description:
      "Bien que le fauteuil roulant soit souvent utilisé comme symbole du handicap ♿, il ne concerne en réalité que 3 % des personnes en situation de handicap.",
  },
  {
    id: 5,
    name: "entry.1503948602",
    type: "radio",
    title:
      "Il est possible d'être en situation de handicap sans déficience intellectuelle.",
    selectMax: 1,
    images: { left: "leopard-print.jpg", right: "question-5.png" },
    answers: [
      {
        label: "Vrai",
        value: "Vrai",
      },
      {
        label: "Faux",
        value: "Faux",
      },
    ],
    rightAnswers: [
      {
        answer: "Vrai",
      },
    ],
    description:
      "⚠️ Qui dit handicap ne dit pas forcément handicap intellectuel.\n\n💡 Il existe différentes formes de handicap, comme le handicap moteur, visuel, auditif, mental, cognitif et psychique.\n\n🤔 Chacune a ses spécificités et ne reflète pas nécessairement une atteinte aux capacités intellectuelles.",
  },
  {
    id: 6,
    name: "entry.889951144",
    type: "radio",
    title:
      "Lorsqu'un collègue en situation de handicap rejoint l'équipe, quelle est la meilleure attitude à adopter ?",
    selectMax: 1,
    images: { left: "leopard-print2.jpg", right: "question-1.png" },
    answers: [
      {
        label: "L'interroger immédiatement sur son handicap pour tout savoir",
        value: "L'interroger immédiatement sur son handicap pour tout savoir",
      },
      {
        label: "Éviter d'aborder le sujet à tout prix",
        value: "Éviter d'aborder le sujet à tout prix",
      },
      {
        label:
          "Se comporter naturellement et lui poser des questions si nécessaire",
        value:
          "Se comporter naturellement et lui poser des questions si nécessaire",
      },
      {
        label: "Lui demander sa pathologie pour comprendre",
        value: "Lui demander sa pathologie pour comprendre",
      },
    ],
    rightAnswers: [
      {
        answer:
          "Se comporter naturellement et lui poser des questions si nécessaire",
      },
    ],
    description:
      "Adopter une attitude naturelle favorise un environnement inclusif et respectueux. 🌿\n\n❓ Évitez de poser des questions intrusives ou de faire des suppositions.\n\n🤝 Si besoin, demandez directement et avec tact quelles adaptations pourraient aider, tout en respectant le choix de partager ou non.",
  },
  {
    id: 7,
    name: "entry.1027728562",
    type: "checkbox",
    title:
      "Quels sont les avantages de l'inclusion des personnes en situation de handicap dans une entreprise ?",
    selectMax: 1,
    images: { left: "leopard-print.jpg", right: "question-2.png" },
    answers: [
      {
        label:
          "Favoriser la diversité au sein des équipes et enrichir les perspectives",
        value:
          "Favoriser la diversité au sein des équipes et enrichir les perspectives",
      },
      {
        label: "Atteindre uniquement un quota imposé par la loi",
        value: "Atteindre uniquement un quota imposé par la loi",
      },
      {
        label:
          "Améliorer l'image de l'entreprise tout en libérant la parole au travail",
        value:
          "Améliorer l'image de l'entreprise tout en libérant la parole au travail",
      },
      {
        label: "Réaliser des économies en embauchant à moindre coût",
        value: "Réaliser des économies en embauchant à moindre coût",
      },
    ],
    rightAnswers: [
      {
        answer:
          "Favoriser la diversité au sein des équipes et enrichir les perspectives",
      },
      {
        answer:
          "Améliorer l'image de l'entreprise tout en libérant la parole au travail",
      },
    ],
    description:
      "Inclure des personnes en situation de handicap permet d'enrichir les équipes grâce à la diversité des expériences et des points de vue, tout en favorisant une culture d'ouverture et de respect.\n\n🤝 Cela contribue également à un meilleur climat de travail et à l'innovation, au-delà du simple respect des obligations légales.",
  },
  {
    id: 8,
    name: "entry.1373805224",
    type: "radio",
    title:
      "Quelles adaptations peuvent être mises en place pour un salarié en situation de handicap ?",
    selectMax: 1,
    images: { left: "leopard-print2.jpg", right: "question-3.png" },
    answers: [
      {
        label: "Ajustement des horaires de travail",
        value: "Ajustement des horaires de travail",
      },
      {
        label: "Aménagement du poste de travail avec du matériel spécifique",
        value: "Aménagement du poste de travail avec du matériel spécifique",
      },
      {
        label: "Télétravail partiel si possible",
        value: "Télétravail partiel si possible",
      },
      {
        label: "Toutes les réponses ci-dessus",
        value: "Toutes les réponses ci-dessus",
      },
    ],
    rightAnswers: [
      {
        answer: "Toutes les réponses ci-dessus",
      },
    ],
    description:
      "Les adaptations peuvent être : \n- Horaires (ex. : temps partiel, pauses régulières, horaires décalés)\n- Organisationnelles (ex. : aide humaine, salle pour s'isoler)\n- Matérielles (ex. : équipement ergonomique, outils compensatoires, logiciels spécifiques)\n\n💡 Ces aménagements sont décidés en fonction de chaque situation, en concertation avec la médecine du travail, pour répondre au mieux aux besoins individuels.",
  },
  {
    id: 9,
    name: "entry.747803072",
    type: "radio",
    title:
      "Que faire si un client exprime une remarque discriminante à propos d'un collègue en situation de handicap ?",
    selectMax: 1,
    images: { left: "leopard-print.jpg", right: "question-4.png" },
    answers: [
      {
        label: "Ignorer la remarque pour éviter de créer un conflit",
        value: "Ignorer la remarque pour éviter de créer un conflit",
      },
      {
        label:
          "Rester en soutien du collègue tout en rappelant au client calmement que son propos est inapproprié",
        value:
          "Rester en soutien du collègue tout en rappelant au client calmement que son propos est inapproprié",
      },
      {
        label: "Référer le client à la direction pour régler le problème",
        value: "Référer le client à la direction pour régler le problème",
      },
      {
        label: "Accepter ses remarques pour éviter de perdre un client",
        value: "Accepter ses remarques pour éviter de perdre un client",
      },
    ],
    rightAnswers: [
      {
        answer:
          "Rester en soutien du collègue tout en rappelant au client calmement que son propos est inapproprié",
      },
    ],
    description:
      "💡 Il est important de réagir de manière calme et pédagogique face à des remarques discriminantes.\n\n🤝 Expliquer que l'entreprise s'engage pour l'inclusion et le respect permet de rappeler les valeurs fondamentales, tout en désamorçant le conflit.\n\n🌱 Cela contribue également à sensibiliser sur l'importance du respect de chacun.",
  },
  {
    id: 10,
    name: "entry.1217596341",
    type: "radio",
    title:
      "Quels peuvent être les signes d'une situation de handicap chez un collègue ?",
    selectMax: 1,
    images: { left: "leopard-print2.jpg", right: "question-5.png" },
    answers: [
      {
        label: "Des changements d'humeurs fréquents ou imprévisibles",
        value: "Des changements d'humeurs fréquents ou imprévisibles",
      },
      {
        label: "Une tendance à s'isoler ou à éviter les interactions sociales",
        value: "Une tendance à s'isoler ou à éviter les interactions sociales",
      },
      {
        label: "Des difficultés à se concentrer sur des tâches complexes",
        value: "Des difficultés à se concentrer sur des tâches complexes",
      },
      {
        label: "Toutes les réponses ci-dessus",
        value: "Toutes les réponses ci-dessus",
      },
    ],
    rightAnswers: [
      {
        answer: "Toutes les réponses ci-dessus",
      },
    ],
    description:
      "🔍 Les signes d'une situation de handicap peuvent inclure des changements ou des comportements inhabituels, comme des :\n- Variations d'humeur\n- Une prise de distance sociale\n- Des difficultés à accomplir certaines tâches\n- ...\n\n💡 Ces signes ne doivent pas être interprétés trop rapidement ; il est important de rester attentif, bienveillant et d'offrir un espace de dialogue respectueux si la personne souhaite partager ses besoins ou ressentis.",
  },
  {
    id: 11,
    name: "entry.198179632",
    type: "checkbox",
    title:
      "Comment réagir si un collègue en situation de handicap semble en détresse ou exprime une difficulté ?",
    selectMax: 1,
    images: { left: "leopard-print.jpg", right: "question-1.png" },
    answers: [
      {
        label:
          "Lui proposer une discussion en privé pour comprendre son besoin",
        value:
          "Lui proposer une discussion en privé pour comprendre son besoin",
      },
      {
        label: "Ignorer la situation pour ne pas le mettre mal à l'aise",
        value: "Ignorer la situation pour ne pas le mettre mal à l'aise",
      },
      {
        label: "Informer le manager",
        value: "Informer le manager",
      },
      {
        label: "Attendre que la personne fasse une demande claire",
        value: "Attendre que la personne fasse une demande claire",
      },
    ],
    rightAnswers: [
      {
        answer:
          "Lui proposer une discussion en privé pour comprendre son besoin",
      },
      {
        answer: "Informer le manager",
      },
    ],
    description:
      "Si un collègue semble en détresse ou rencontre une difficulté, il est important d'adopter une approche discrète et bienveillante.\n\n🤝 Proposez-lui une discussion en privé pour comprendre ses besoins et lui offrir votre soutien, tout en respectant ses choix.\n\n📢 Si nécessaire, il peut être utile d'en informer le manager, seulement après avoir obtenu l'accord du collègue concerné (sauf en cas d'urgence ou de situation critique).",
  },
  {
    id: 12,
    name: "entry.1063851083",
    type: "radio",
    title: "En tant que vendeur, comment accueillir un client malentendant ?",
    selectMax: 1,
    images: { left: "leopard-print2.jpg", right: "question-2.png" },
    answers: [
      {
        label: "Prendre l'initiative de parler plus fort pour compenser",
        value: "Prendre l'initiative de parler plus fort pour compenser",
      },
      {
        label: "Parler face à la personne pour faciliter la lecture labiale",
        value: "Parler face à la personne pour faciliter la lecture labiale",
      },
      {
        label: "Demander à un collègue de prendre en charge",
        value: "Demander à un collègue de prendre en charge",
      },
    ],
    rightAnswers: [
      {
        answer: "Parler face à la personne pour faciliter la lecture labiale",
      },
    ],
    description:
      "Pour bien accueillir un client malentendant, il est essentiel de se placer face à lui afin de faciliter la lecture labiale et d'utiliser un ton de voix naturel. 👋\n\n🔊 Parler plus fort peut déformer les mots et rendre la communication plus difficile.\n\n✍️ Si nécessaire, utilisez des gestes ou écrivez pour clarifier.",
  },
  {
    id: 13,
    name: "entry.1805704474",
    type: "radio",
    title:
      "Quelle est la meilleure attitude face à un client ayant des difficultés de communication ?",
    selectMax: 1,
    images: { left: "leopard-print.jpg", right: "question-3.png" },
    answers: [
      {
        label: "Interrompre pour reformuler sa demande",
        value: "Interrompre pour reformuler sa demande",
      },
      {
        label: "Prendre le temps d'écouter sans presser",
        value: "Prendre le temps d'écouter sans presser",
      },
      {
        label: "Proposer de continuer uniquement par écrit",
        value: "Proposer de continuer uniquement par écrit",
      },
      {
        label: "Rediriger le client vers un supérieur",
        value: "Rediriger le client vers un supérieur",
      },
    ],
    rightAnswers: [
      {
        answer: "Prendre le temps d'écouter sans presser",
      },
    ],
    description:
      "La meilleure attitude face à un client ayant des difficultés de communication est de lui laisser le temps d'exprimer sa demande sans interruption ni précipitation.\n\n⏳ Montrer de la patience et de l'attention contribue à instaurer un climat de confiance où il pourra se sentir à l'aise pour formuler ses besoins.",
  },
  {
    id: 14,
    name: "entry.909771729",
    type: "radio",
    title:
      "Un client malvoyant préfère toujours être guidé en lui prenant le bras.",
    selectMax: 1,
    images: { left: "leopard-print2.jpg", right: "question-4.png" },
    answers: [
      {
        label: "Vrai",
        value: "Vrai",
      },
      {
        label: "Faux",
        value: "Faux",
      },
    ],
    rightAnswers: [
      {
        answer: "Faux",
      },
    ],
    description:
      "💡 Un client malvoyant reste une personne autonome et indépendante. N'oubliez pas que s'il a besoin de votre aide, il saura vous la demander.\nComme chacun de vos clients, il ne faut pas hésiter à aller à la rencontre du client pour lui demander s'il a besoin d'aide ou renseignements.",
  },
  {
    id: 15,
    name: "entry.747474921",
    type: "radio",
    title:
      "Comment aider un client malvoyant à trouver un produit spécifique ?",
    selectMax: 1,
    images: { left: "leopard-print.jpg", right: "question-5.png" },
    answers: [
      {
        label: "Lui proposer de toucher les produits pour les découvrir",
        value: "Lui proposer de toucher les produits pour les découvrir",
      },
      {
        label: "Décrire précisément les articles disponibles",
        value: "Décrire précisément les articles disponibles",
      },
      {
        label:
          "Le guider jusqu'au produit en lui proposant le bras si nécessaire",
        value:
          "Le guider jusqu'au produit en lui proposant le bras si nécessaire",
      },
      {
        label: "Toutes les réponses ci-dessus",
        value: "Toutes les réponses ci-dessus",
      },
    ],
    rightAnswers: [
      {
        answer: "Toutes les réponses ci-dessus",
      },
    ],
    description:
      "Aider un client malvoyant peut inclure plusieurs approches adaptées à ses besoins.\n\nVous pouvez décrire les articles de manière détaillée, l'accompagner physiquement en lui proposant votre bras s'il le souhaite, ou lui permettre de toucher les produits pour mieux les identifier.\n\n☝️ L'important est de proposer son aide plutôt que de l'imposer.",
  },
  {
    id: 16,
    name: "entry.666961772",
    type: "radio",
    title:
      "Comment identifier si un client en difficulté a besoin d'aide sans le stigmatiser ?",
    selectMax: 1,
    images: { left: "leopard-print2.jpg", right: "question-1.png" },
    answers: [
      {
        label: "Lui demander directement s'il a un handicap",
        value: "Lui demander directement s'il a un handicap",
      },
      {
        label: "Observer et proposer de l'aide discrètement si nécessaire",
        value: "Observer et proposer de l'aide discrètement si nécessaire",
      },
      {
        label: "Appeler un responsable pour gérer la situation",
        value: "Appeler un responsable pour gérer la situation",
      },
      {
        label: "Ignorer la situation pour ne pas le mettre mal à l'aise",
        value: "Ignorer la situation pour ne pas le mettre mal à l'aise",
      },
    ],
    rightAnswers: [
      {
        answer: "Observer et proposer de l'aide discrètement si nécessaire",
      },
    ],
    description:
      "Qu'il s'agisse d'un handicap ou non, il est possible qu'une personne ait besoin d'aide.\n\n🤝 Dans ce cas, comme à votre habitude, analysez la situation, ne l'ignorez pas, et proposez-lui votre aide de manière discrète et respectueuse, sans insister si elle refuse.\n\n😊 Adoptez une attitude naturelle et bienveillante pour mettre la personne à l'aise et lui montrer votre disponibilité.",
  },
  {
    id: 17,
    name: "entry.8994285",
    type: "radio",
    title:
      "Lors d'une vente, comment s'assurer qu'un client en situation de handicap se sente bien accueilli ?",
    selectMax: 1,
    images: { left: "leopard-print.jpg", right: "question-2.png" },
    answers: [
      {
        label:
          "Lui poser directement des questions sur la nature de son handicap",
        value:
          "Lui poser directement des questions sur la nature de son handicap",
      },
      {
        label: "Adopter une attitude naturelle et bienveillante",
        value: "Adopter une attitude naturelle et bienveillante",
      },
      {
        label: "Éviter toute interaction pour ne pas risquer de maladresse",
        value: "Éviter toute interaction pour ne pas risquer de maladresse",
      },
      {
        label: "Lui donner immédiatement des réductions spéciales",
        value: "Lui donner immédiatement des réductions spéciales",
      },
    ],
    rightAnswers: [
      {
        answer: "Adopter une attitude naturelle et bienveillante",
      },
    ],
    description:
      "Il est essentiel d'adopter une attitude naturelle, bienveillante et respectueuse pour accueillir tous les clients.\n\n❓ Inutile de poser des questions sur leur situation personnelle même si vous suspectez une situation de handicap.\n\n💡 Rappelez-vous qu'une personne souhaite avant tout vivre normalement, sans être réduite à son handicap. Votre attitude positive et inclusive peut grandement y contribuer.\n\n🤝 Concentrez-vous sur leurs besoins immédiats et faites en sorte que tous vos clients se sentent à l'aise.",
  },
  {
    id: 18,
    name: "entry.1800844475",
    type: "radio",
    title:
      "Comment reconnaître qu'un client atteint d'un trouble cognitif pourrait avoir besoin d'une assistance ?",
    selectMax: 1,
    images: { left: "leopard-print2.jpg", right: "question-3.png" },
    answers: [
      {
        label: "Il demande à plusieurs reprises des informations déjà fournies",
        value: "Il demande à plusieurs reprises des informations déjà fournies",
      },
      {
        label:
          "Il semble confus ou perdu en suivant les indications du magasin",
        value:
          "Il semble confus ou perdu en suivant les indications du magasin",
      },
      {
        label: "Il s'arrête fréquemment pour se repérer ou lire des panneaux",
        value: "Il s'arrête fréquemment pour se repérer ou lire des panneaux",
      },
      {
        label: "Toutes les réponses ci-dessus",
        value: "Toutes les réponses ci-dessus",
      },
    ],
    rightAnswers: [
      {
        answer: "Toutes les réponses ci-dessus",
      },
    ],
    description:
      "Certains comportements peuvent indiquer qu'un client a besoin d'aide, comme demander plusieurs fois des informations, paraître confus, ou s'arrêter souvent pour se repérer.\n\n🤔 Ces signes ne doivent pas mener à des suppositions, mais à une approche bienveillante et adaptée.\n\n🤝 Proposez de l'assistance discrètement, en respectant ses choix et son autonomie.",
  },
  {
    id: 19,
    name: "entry.842241093",
    type: "checkbox",
    title: "Comment proposer son aide à un client en fauteuil roulant ?",
    selectMax: 1,
    images: { left: "leopard-print.jpg", right: "question-4.png" },
    answers: [
      {
        label:
          "Demander si vous pouvez lui apporter un produit, une information",
        value:
          "Demander si vous pouvez lui apporter un produit, une information",
      },
      {
        label:
          "Assurer l'accessibilité des zones du magasin en déplaçant dans la mesure du possible les obstacles",
        value:
          "Assurer l'accessibilité des zones du magasin en déplaçant dans la mesure du possible les obstacles",
      },
      {
        label:
          "Le laisser gérer seul ses déplacements pour respecter son autonomie",
        value:
          "Le laisser gérer seul ses déplacements pour respecter son autonomie",
      },
      {
        label:
          "Prendre l'initiative de pousser son fauteuil pour circuler dans le magasin",
        value:
          "Prendre l'initiative de pousser son fauteuil pour circuler dans le magasin",
      },
    ],
    rightAnswers: [
      {
        answer:
          "Demander si vous pouvez lui apporter un produit, une information",
      },
      {
        answer:
          "Assurer l'accessibilité des zones du magasin en déplaçant dans la mesure du possible les obstacles",
      },
      {
        answer:
          "Le laisser gérer seul ses déplacements pour respecter son autonomie",
      },
    ],
    description:
      "Respecter l'autonomie de chaque personne utilisant un fauteuil roulant est essentiel.\n\n🤝 Vous pouvez proposer votre aide de manière respectueuse, comme déplacer des obstacles ou apporter un produit, mais toujours en demandant au préalable.\n\n🙌 Si la personne préfère gérer seule ses déplacements, il est important de respecter son choix.\n\n🚫 En revanche, ne poussez jamais un fauteuil sans y avoir été invité, par souci de respect et de consentement.",
  },
  {
    id: 20,
    name: "entry.273495025",
    type: "radio",
    title:
      "Si un client sourd est accompagné d'un interprète en langue des signes, il est préférable de s'adresser directement à l'interprète.",
    selectMax: 1,
    images: { left: "leopard-print2.jpg", right: "question-5.png" },
    answers: [
      {
        label: "Vrai",
        value: "Vrai",
      },
      {
        label: "Faux",
        value: "Faux",
      },
    ],
    rightAnswers: [
      {
        answer: "Faux",
      },
    ],
    description:
      "Lorsque vous interagissez avec une personne sourde accompagnée d'un interprète, adressez-vous directement à la personne concernée et non à l'interprète.\n\n👁️ Maintenez un contact visuel et une communication directe pour montrer du respect et favoriser une relation inclusive.\n\n🤝 Rappelez-vous que l'interprète est là pour faciliter la compréhension, mais pas pour prendre la place de votre interlocuteur.",
  },
  {
    id: 21,
    name: "entry.1202653957",
    type: "radio",
    title:
      "Comment réagir si un client ayant un handicap invisible présente une carte de priorité en caisse lors d'une forte affluence ?",
    selectMax: 1,
    images: { left: "leopard-print.jpg", right: "question-1.png" },
    answers: [
      {
        label:
          "Lui demander de prouver qu'il est bien le titulaire de la carte",
        value:
          "Lui demander de prouver qu'il est bien le titulaire de la carte",
      },
      {
        label: "Lui accorder une priorité immédiate sans poser de questions",
        value: "Lui accorder une priorité immédiate sans poser de questions",
      },
      {
        label:
          "Vérifier discrètement si la carte est à son nom, en lui posant des questions indirectes",
        value:
          "Vérifier discrètement si la carte est à son nom, en lui posant des questions indirectes",
      },
      {
        label:
          "L'informer que la carte de priorité n'est valable que pour les personnes avec un handicap visible",
        value:
          "L'informer que la carte de priorité n'est valable que pour les personnes avec un handicap visible",
      },
    ],
    rightAnswers: [
      {
        answer: "Lui accorder une priorité immédiate sans poser de questions",
      },
    ],
    description:
      "Certaines situations de handicap ne sont pas visibles, mais cela n'enlève rien à leur légitimité.\n\nSi une personne présente une carte de priorité, il est essentiel de respecter sa demande en lui accordant la priorité, sans poser de questions intrusives ni émettre de jugements.\n\n🚫 Il ne faut pas demander de preuves, vérifier discrètement l'identité ou supposer que seuls les handicaps visibles justifient une carte de priorité.\n\n🤝 Adopter une attitude bienveillante contribue à garantir un accueil inclusif et respectueux pour tous.",
  },
];

export default questions;
